// import React from 'react';
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FacebookLogin from 'react-facebook-login';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import Recaptcha from 'react-recaptcha';
import { loginUser, ForgotPassword, googleLogin } from './../../Redux/Actions/UserAction';
import { logout } from '../../Redux/Actions/UserAction';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import GoogleLogin from '../common/GoogleLogin';
import { GOOGLE_LOGIN_ENABLED } from '../../config/api';

const Login = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });
  const [inputs, setInputs] = useState({
    username: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [submitted, Setsubmitted] = useState(false);
  // const registering = useSelector(state => state.registration.registering);
  const dispatch = useDispatch();

  // reset login status
  useEffect(() => {
    // dispatch(logout());
  }, []);

  // Redirect to hash-based route if needed
  useEffect(() => {
    if (window.location.pathname === '/login' && window.location.hash !== '#/login') {
      window.location.href = `/#/login${window.location.search}`;
      return;
    }
  }, []);

  // Handle Google OAuth callback
  useEffect(() => {
    console.log('Login component mounted, checking for OAuth params...');
    console.log('Current location.search:', location.search);
    
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    console.log('Code found:', code);
    console.log('Error found:', error);

    if (code) {
      console.log('🚀 CALLING GOOGLE LOGIN API WITH CODE:', code);
      
      // Prepare data for backend
      const googleData = {
        code: code,
        scope: 'openid email profile'
      };

      console.log('🚀 Sending data to backend:', googleData);
      
      // Dispatch Google login action
      dispatch(googleLogin(googleData));
    } else if (error) {
      console.error('Google OAuth error:', error);
      Swal.fire({
        title: 'Login Failed',
        text: 'There was an error with Google login. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } else {
      console.log('No OAuth parameters found');
    }
  }, [location.search, dispatch]);

  function handleChange(e) {
    const { name, value } = e.target;
    setInputs((user) => ({ ...user, [name]: value }));
  }

  function onLogin(e) {
    // e.preventDefault();
    console.log(inputs);

    Setsubmitted(true);

    dispatch(loginUser(inputs));
    console.log(inputs);
  }

  const ForgotPasswordBtn = () => {
    Swal.fire({
      title: 'Enter your username',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: 'Submit',
      showLoaderOnConfirm: true,
      preConfirm: (userNameData) => {
        const passwordData = { username: userNameData };
        console.log('this is login', passwordData);
        if (
          passwordData.username !== undefined &&
          passwordData.username !== ''
        ) {
          dispatch(ForgotPassword(passwordData));
        } else {
          Swal.showValidationMessage(`this field requird`);
        }
      },
    });
  };
  return (
    <div class="login-reg-area">
      <div class="container">
        <div class="login-reg-wrap">
          <h1 class="mb-5">{t('login')}</h1>

          <form onSubmit={handleSubmit(onLogin)}>
            <div class="form-group">
              <label for="login-email" class="sr-only">
                {t('username')}
              </label>
              <input
                // {...register('username', {
                // 	required: 'this field is requerd',
                // 	minLength: {
                // 		value: 6,
                // 		message: 'username should be minimum  6 character',
                // 	},
                // 	pattern: {
                // 		value: /^[a-zA-Z0-9](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9]){6,18}[a-zA-Z0-9]$/,
                // 		message:
                // 			'username can only use letters,numbers, minimum length is 6 characters',
                // 	},
                // })}
                name="username"
                value={inputs.username}
                type="username"
                className={classNames('form-control', {
                  'is-invalid': errors.username,
                })}
                id="login-email"
                placeholder={t('username')}
                // name='username'
                required=""
                onChange={handleChange}
              />
              {errors.username && (
                <p className="invalid-feedback">{errors.username.message}</p>
              )}
            </div>
            <div class="form-group" style={{ position: 'relative' }}>
              <label for="login-password" class="sr-only">
                {t('password')}
              </label>
              <input
                // {...register('password', {
                // 	required: 'this field is requerd',
                // 	minLength: {
                // 		value: 8,
                // 		message: 'Password must have at least 8 characters',
                // 	},
                // 	pattern: {
                // 		value: /(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,50}$/,
                // 		message: 'plese try another password',
                // 	},
                // })}
                name="password"
                value={inputs.password}
                type={showPassword ? 'text' : 'password'}
                // name='password'
                className={classNames('form-control', {
                  'is-invalid': errors.password,
                })}
                id="login-password"
                placeholder={t('password')}
                required=""
                style={{ paddingRight: '42px' }}
                onChange={handleChange}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '14px',
                  top: '12px',
                  cursor: 'pointer',
                  color: '#888',
                  zIndex: 5,
                }}
              >
                <i className={showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'}></i>
              </span>
              {errors.password && (
                <p className="invalid-feedback">{errors.password.message}</p>
              )}
            </div>

            <div class="form-group">
              <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                  {/* [CF] Checkbox + label wrapped in one flex label with `gap`
                      so the box sits snug next to the text in BOTH LTR and RTL
                      (Bootstrap's .form-check-inline uses negative left margins
                      that detached the box from the label in Arabic). */}
                  <label
                    htmlFor="inlineCheckbox1"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      margin: 0,
                      cursor: 'pointer',
                      userSelect: 'none',
                    }}
                  >
                    <input
                      {...register('terms', {
                        // required: 'this field is requerd',
                        minLength: {
                          value: 4,
                          message: '',
                        },
                      })}
                      className={classNames({
                        'is-invalid': errors.terms,
                      })}
                      type="checkbox"
                      id="inlineCheckbox1"
                      value="option1"
                      name="terms"
                      style={{
                        position: 'static',
                        margin: 0,
                        width: '16px',
                        height: '16px',
                        flexShrink: 0,
                        accentColor: '#f7b500',
                        cursor: 'pointer',
                      }}
                    />
                    <span>{t('Remember me')}</span>
                  </label>
                </div>
                <div class="col-auto">
                  <Link to="/reset-password" href="javascript:void(0);">
                    {t('Forget Password')}
                  </Link>
                </div>
              </div>
            </div>

            <button
              type="submit"
              class="btn btn-warning btn-block"
              onSubmit={handleSubmit(onLogin)}
            >
              {t('login')}
            </button>

            {GOOGLE_LOGIN_ENABLED && (
              <div class="row justify-content-center no-gutters mt-4">
                <div class="col-12">
                  <GoogleLogin />
                </div>
              </div>
            )}

            <hr class="mt-4 mb-4" />

            <p class="mb-0 text-center">
              {t("Don't have an account?")}
              <Link to="/register">{t('Register now')}</Link>
              {/* <Link to='/OtpVerification'>Register now!</Link> */}
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;

// Login.propsTypes = {
// 	loginUser: PropTypes.func.isRequired,
// 	home: PropTypes.object.isRequired,
// };
